import dayjs from "dayjs";

export const cx = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};

export const formatDate = (date: string) => {
  return dayjs(date).format("DD MMM YYYY");
};

export const formatCurrency = (num?: number, decimal: number = 2) => {
  const inrCurrencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: decimal,
  });
  return inrCurrencyFormatter.format(num || 0);
};

export const formatPercentage = (num?: number) => {
  const inrPercentageFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
  });
  return inrPercentageFormatter.format(num || 0);
};

export const formatDecimal = (num?: number) => {
  const inrDecimalFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  return inrDecimalFormatter.format(num || 0);
};

export const summarizeCurrency = (num: number) => {
  const inrCurrencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    notation: "compact",
  });
  return inrCurrencyFormatter.format(num);
};

export const capitalize = (s: string) => {
  return s ? s.charAt(0).toUpperCase() + s.substring(1).toLowerCase() : "";
};
export const titleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");
};
export const now = new Date();
export const API_URL = process.env.REACT_APP_API_URL;
export const gateway_name = "capricornemindframe";

export const statesAndUTsOfIndia = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Lakshadweep",
  "Delhi",
  "Puducherry",
  "Ladakh",
  "Jammu and Kashmir",
];
